//Variables para internacionalización
const grid_add_button = window.i18n.grid_add_button;
const grid_remove_button = window.i18n.grid_remove_button;
const limit_modal_upgrade_msg = window.i18n.limit_modal_upgrade_msg;
const limit_modal_upgrade_qstn = window.i18n.limit_modal_upgrade_qstn;
const incomplete_modal_msg1 = window.i18n.incomplete_modal_msg1;
const incomplete_modal_msg2 = window.i18n.incomplete_modal_msg2;


// Retrieve local store values if they exist
let selectedProducts = JSON.parse(localStorage.getItem('selectedProducts')) || [];
let productLimit = parseInt(localStorage.getItem('productLimit'), 10);
let productLimits = JSON.parse(localStorage.getItem('productLimits'));

// Update counter and button label
function updateCounter() {
    const counterElement = document.getElementById('product-counter');
    counterElement.textContent = selectedProducts.length;
}

// Find the next available limit
function getNextLimit() {
    const currentIndex = productLimits.indexOf(productLimit);
    return currentIndex !== -1 && currentIndex < productLimits.length - 1 
        ? productLimits[currentIndex + 1] 
        : null;
}

// Restore already selected products
function restoreSelections() {
    selectedProducts.forEach(product => {
        const productCard = document.querySelector(`.product-card[data-id='${product.id}']`);
        if (productCard) {
            const button = productCard.querySelector('.add-button');
            button.textContent = grid_remove_button;
            button.classList.replace('button--secondary', 'button--primary');   
        }
    });
    console.log("articulos ya seleccionados restaurados");
}

// Handle Add/Remove button click
function handleButtonClick(event) {
    const button = event.currentTarget;
    const productCard = button.closest('.product-card');
    const productId = productCard.getAttribute('data-id');
    const productTitle = productCard.getAttribute('data-title');
    //const productAllowsUpload = productCard.getAttribute('data-allows-upload');
    const productAllowsUpload = productCard.getAttribute('data-allows-upload') === "true";
    const isSelected = button.classList.contains('button--primary');
    
    if (!isSelected) {        
        if (selectedProducts.length >= productLimit) {
            showLimitModal();
            return;
        }
        selectedProducts.push({
            id: productId,
            title: productTitle,
            ...(productAllowsUpload ? { allowsUpload: true } : {})
        });
        button.textContent = grid_remove_button;
        button.classList.replace('button--secondary', 'button--primary');         
    } else {
        selectedProducts = selectedProducts.filter(product => product.id !== productId);
        button.textContent = grid_add_button;
        button.classList.replace('button--primary', 'button--secondary');         
    }

    updateCounter();
    saveSelections();
    console.log(selectedProducts);
}

// Show modal when the product limit is reached
function showLimitModal() {
    const modal = document.getElementById('limit-modal');
    const modalMessage = document.getElementById('limit-modal-message');
    const modalQuestion = document.getElementById('limit-modal-question');
    const upgradeButton = document.getElementById('modal-upgrade');

    modalMessage.textContent = limit_modal_upgrade_msg + ' ' + productLimit;

    const nextLimit = getNextLimit();
    console.log(`nextLimit is ${nextLimit}`);

    // Check if there's a next limit available
    if (nextLimit) {
        upgradeButton.style.display = 'inline-block'; // Show the "Upgrade me" button
        modalQuestion.textContent = limit_modal_upgrade_qstn + ' ' + nextLimit + '?';
    } else {
        upgradeButton.style.display = 'none'; // Hide the "Upgrade me" button
        modalQuestion.style.display = 'none';
        document.getElementById('modal-ok').textContent= 'OK';
    }

    modal.style.display = 'flex';
}

// Show modal for when users tries to proceed with less articles than the limit
function showNoselectionModal() {
    const modal = document.getElementById('noselection-modal');
    const modalMessage = document.getElementById('noselection-modal-message');
    const remainingProducts = productLimit - selectedProducts.length;

    modalMessage.textContent = incomplete_modal_msg1 + ' ' + remainingProducts + ' ' + incomplete_modal_msg2;
    modal.style.display = 'flex';
}

// Hide modal
function hideModal(modalId) {
    const modal = document.getElementById(modalId);
    modal.style.display = 'none';
}

// Upgrade the product limit
function upgradeLimit() {
    const nextLimit = getNextLimit();
    if (nextLimit) {
        localStorage.setItem('productLimit', nextLimit);
        productLimit = nextLimit;
        hideModal('limit-modal');  // Hide the modal after upgrading
        console.log(`Product limit upgraded to ${nextLimit}`);
    }
}

// Save selected products to localStorage
function saveSelections() {
    localStorage.setItem('selectedProducts', JSON.stringify(selectedProducts));
}

// Event listener for the "Next" button
document.getElementById('next-button').addEventListener('click', function() {
    if (selectedProducts.length == 0) {
        showNoselectionModal();
    } else if (selectedProducts.length < productLimit) {
        showNoselectionModal();
        
    } else {
        saveSelections();
        if (productLimit==5){
          window.location.href = window.byob_urls.box_s;
        } else if (productLimit==7){
          window.location.href = window.byob_urls.box_m;
        } else {
          window.location.href = window.byob_urls.box_l;
        }
    }
});

// Event listeners for modal buttons
document.getElementById('modal-ok').addEventListener('click', () => hideModal('limit-modal'));
document.getElementById('noselection-ok').addEventListener('click', () => hideModal('noselection-modal'));
document.getElementById('modal-upgrade').addEventListener('click', upgradeLimit);

document.getElementById('confirm-ok').addEventListener('click', function() {
    saveSelections();
    if (productLimit==5){
          window.location.href = window.byob_urls.box_s;
        } else if (productLimit==7){
          window.location.href = window.byob_urls.box_m;
        } else {
          window.location.href = window.byob_urls.box_l;
        }
});
document.getElementById('confirm-cancel').addEventListener('click', () => hideModal('confirm-modal'));

// Event listeners for add/remove buttons
function addListenersToButtons() {
    console.log("Añadiendo listeners a botones");
  document.querySelectorAll('.add-button').forEach(button => {
      button.removeEventListener('click', handleButtonClick); // Evita duplicados
      button.addEventListener('click', handleButtonClick);    // Añade listener limpio
  });
}

// Initialize the counter and restore previous selections
updateCounter();
restoreSelections();
addListenersToButtons();



// Image zoom in PLP alecustombox
function initializeImageZoomModal() {
    const zoomModal = document.getElementById("zoom-modal");
    const zoomModalImage = document.getElementById("zoom-modal-image");
    const closeZoomModal = document.querySelector(".zoom-modal-close");

    // Open modal on image click
    document.querySelectorAll(".zoom-modal-trigger").forEach(img => {
        img.addEventListener("click", function () {
            // Create a URL object to modify the image URL
            //const urlObject = new URL(img.src, window.location.origin);
            //urlObject.searchParams.delete('width'); // Remove 'width' parameter
            console.log("Zoom triggered");

            zoomModal.style.display = "flex"; // Show modal
            zoomModalImage.src = img.src;
            //zoomModalImage.src = urlObject.toString(); // Set modal image source to modified URL
            //console.log("img url", zoomModalImage.src);

            // Disable body scroll
            document.body.style.overflow = "hidden"; // Prevent scrolling. !Fixed height on the body or overflow properties set elsewhere, they could affect scrolling behavior.
            
        });
    });

    // Close modal when clicking on the close button
    closeZoomModal.addEventListener("click", function () {
        zoomModal.style.display = "none"; // Hide modal

        // Re-enable body scroll
        document.body.style.overflow = ""; // Restore scrolling
        
    });

    // Close modal when clicking outside of the modal content
    zoomModal.addEventListener("click", function (event) {
        if (event.target === zoomModal) {
            zoomModal.style.display = "none"; // Hide modal

            // Re-enable body scroll
            document.body.style.overflow = ""; // Restore scrolling
        }
    });
    console.log("Zoom modal iniciado");
}

window.addEventListener("load", initializeImageZoomModal);


// Function to initialize event listeners for add/remove buttons and zoom modal
function initializeProductEventListeners() {
    restoreSelections();
    addListenersToButtons();
    initializeImageZoomModal();
    console.log("paso por initialize event listeners");
    
}

// Observer to watch for changes in the product grid 
const productGrid = document.querySelector('.active-facets');
const observer = new MutationObserver(() => {
    initializeProductEventListeners();
    console.log(observer);
});

observer.observe(productGrid, { childList: true, subtree: true });
